import { COMPETENCY_CHECKLIST } from "../apiEndpoint";
import { studentAxios } from "../http/http";
export default function getCompetencyChecklist(Useremail = "") {
  return studentAxios.get(COMPETENCY_CHECKLIST + "?user_email=" + Useremail, {
    headers: {
      ApiKey: process.env.REACT_APP_STUDENT_GO_APIKEY,
    },
  });
}
